// extracted by css-extract-rspack-plugin
export default {"todoContainer":"N2AE6","todoHeader":"nF4n8","primaryColor":"QULRL","todoItem":"KWWcN","statusIndicator":"WYjDe","pendingIndicator":"Bulh6"};